const color = [
  "primary",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "red",
  "orange",
  "amber",
  "yellow",
  "green",
  "emerald",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "purple",
  "pink",
  "neutral"
] as const

export default {
  "slots": {
    "root": "relative group overflow-hidden bg-default shadow-lg rounded-lg ring ring-default p-4 flex gap-2.5",
    "wrapper": "w-0 flex-1 flex flex-col",
    "title": "text-sm font-medium text-highlighted",
    "description": "text-sm text-muted",
    "icon": "shrink-0 size-5",
    "avatar": "shrink-0",
    "avatarSize": "2xl",
    "actions": "flex gap-1.5 shrink-0",
    "progress": "absolute inset-x-0 bottom-0",
    "close": "p-0"
  },
  "variants": {
    "color": {
      "primary": {
        "root": "outline-primary/25 focus-visible:outline-3 focus-visible:ring-primary",
        "icon": "text-primary"
      },
      "secondary": {
        "root": "outline-secondary/25 focus-visible:outline-3 focus-visible:ring-secondary",
        "icon": "text-secondary"
      },
      "success": {
        "root": "outline-success/25 focus-visible:outline-3 focus-visible:ring-success",
        "icon": "text-success"
      },
      "info": {
        "root": "outline-info/25 focus-visible:outline-3 focus-visible:ring-info",
        "icon": "text-info"
      },
      "warning": {
        "root": "outline-warning/25 focus-visible:outline-3 focus-visible:ring-warning",
        "icon": "text-warning"
      },
      "error": {
        "root": "outline-error/25 focus-visible:outline-3 focus-visible:ring-error",
        "icon": "text-error"
      },
      "red": {
        "root": "outline-red/25 focus-visible:outline-3 focus-visible:ring-red",
        "icon": "text-red"
      },
      "orange": {
        "root": "outline-orange/25 focus-visible:outline-3 focus-visible:ring-orange",
        "icon": "text-orange"
      },
      "amber": {
        "root": "outline-amber/25 focus-visible:outline-3 focus-visible:ring-amber",
        "icon": "text-amber"
      },
      "yellow": {
        "root": "outline-yellow/25 focus-visible:outline-3 focus-visible:ring-yellow",
        "icon": "text-yellow"
      },
      "green": {
        "root": "outline-green/25 focus-visible:outline-3 focus-visible:ring-green",
        "icon": "text-green"
      },
      "emerald": {
        "root": "outline-emerald/25 focus-visible:outline-3 focus-visible:ring-emerald",
        "icon": "text-emerald"
      },
      "teal": {
        "root": "outline-teal/25 focus-visible:outline-3 focus-visible:ring-teal",
        "icon": "text-teal"
      },
      "cyan": {
        "root": "outline-cyan/25 focus-visible:outline-3 focus-visible:ring-cyan",
        "icon": "text-cyan"
      },
      "blue": {
        "root": "outline-blue/25 focus-visible:outline-3 focus-visible:ring-blue",
        "icon": "text-blue"
      },
      "indigo": {
        "root": "outline-indigo/25 focus-visible:outline-3 focus-visible:ring-indigo",
        "icon": "text-indigo"
      },
      "purple": {
        "root": "outline-purple/25 focus-visible:outline-3 focus-visible:ring-purple",
        "icon": "text-purple"
      },
      "pink": {
        "root": "outline-pink/25 focus-visible:outline-3 focus-visible:ring-pink",
        "icon": "text-pink"
      },
      "neutral": {
        "root": "outline-inverted/25 focus-visible:outline-3 focus-visible:ring-inverted",
        "icon": "text-highlighted"
      }
    },
    "orientation": {
      "horizontal": {
        "root": "items-center",
        "actions": "items-center"
      },
      "vertical": {
        "root": "items-start",
        "actions": "items-start mt-2.5"
      }
    },
    "title": {
      "true": {
        "description": "mt-1"
      }
    }
  },
  "defaultVariants": {
    "color": "primary" as typeof color[number]
  }
}